import type { UIComponent } from "@gik/core/types/UI";
import { useBemCN } from "@gik/core/utils/bemBlock";
import type React from "react";

export type FlexGridProps = {
	flexChildren?: boolean;
} & UIComponent;

export function FlexGrid({
	className,
	children,
	flexChildren,
	...otherProps
}: React.PropsWithChildren<FlexGridProps>): React.ReactElement {
	const bem = useBemCN("flex-grid2");

	return (
		<div
			{...otherProps}
			{...bem(null, [{ ["flex-children"]: flexChildren }], [className])}
		>
			{children}
		</div>
	);
}
